const runtimeOrigin =
	typeof window !== "undefined" && window.location?.origin
		? window.location.origin
		: "http://localhost:8080";

const STATIC_BASE_URL =
	(process.env.REACT_APP_STATIC_BASE_URL || "").trim() ||
	(process.env.NODE_ENV === "development" ? "http://localhost:8080" : runtimeOrigin);

export default STATIC_BASE_URL;
